import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Badge } from '../../../models/badge.model';
import { ShareCardsService } from '../../../services/share-cards.service';

@Component({
  selector: 'app-badge-unlock-modal',
  templateUrl: './badge-unlock-modal.component.html',
  styleUrls: ['./badge-unlock-modal.component.scss'],
  standalone: false,
})
export class BadgeUnlockModalComponent {
  constructor(
    public dialogRef: MatDialogRef<BadgeUnlockModalComponent>,
    private shareCards: ShareCardsService,
    @Inject(MAT_DIALOG_DATA)
    public data: { badges: Badge[] },
  ) {}

  share(badge: Badge): void {
    void this.shareCards.shareBadge(badge);
  }
}
